export default {
  partnerListWithDetails: []
}